import React from 'react';
import PropTypes from 'prop-types';
import { css, withStyles, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';
import Spacing from 'airbnb-dls-web/build/exp/Spacing';
import Text from 'airbnb-dls-web/build/exp/Text';
import VerticalAlignmentContainer, {
  VerticalAlign,
} from 'airbnb-dls-web/build/exp/VerticalAlignmentContainer';

const propTypes = {
  ...withStylesPropTypes,
  event: PropTypes.object.isRequired,
};

function Event({ event, styles, eventType }) {
  const { title, video, date, slides, eventLink, imageLink } = event;

  const eventImage = imageLink || '/img/events/default/default_event.png';
  const slideImage = '/img/events/default/default_slides.png';

  // TODO: refactor the following code for different event cards
  // initial values for regular event cards
  let eventComponentStyle = {
    width: '100%',
    minHeight: 350,
  };
  let textSection = (
    <div>
      <Spacing bottom={2}>
        <div style={{ minHeight: 60 }}>
          <Text>{title}</Text>
        </div>
        {!!date && (
          <Text light micro>
            {new Date(date).toLocaleDateString()}
          </Text>
        )}
      </Spacing>
    </div>
  );

  if (eventType === 'promoted') {
    // overwritten values for promoted event cards
    eventComponentStyle = {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '80%',
      maxHeight: 900,
      overflow: 'hidden',
    };
    textSection = null;
  }

  let contentThumbnail;
  if (video && video.youtube) {
    contentThumbnail = (
      <a href={`https://youtube.com/watch?v=${video.youtube}`}>
        <img alt="" src={`http://img.youtube.com/vi/${video.youtube}/hqdefault.jpg`} width="100%" height="100%" />
      </a>
    );
  } else if (slides) {
    contentThumbnail = (
      <a href={slides} target="_blank">
        <img alt="See Slides" src={slideImage} width="100%" height="100%" />
      </a>
    );
  } else if (eventImage) {
    contentThumbnail = (
      <a href={eventLink} target="_blank">
        <img alt="See event" src={eventImage} width="100%" height="100%" />
      </a>
    );
  } else if (eventLink) {
    contentThumbnail = (
      <a {...css(styles.rectLink)} href={eventLink}>
        <div {...css(styles.slidesRectangle)}>
          <VerticalAlignmentContainer fillVertical fillHorizontal>
            <VerticalAlign middle>
              <Text>See event</Text>
            </VerticalAlign>
          </VerticalAlignmentContainer>
        </div>
      </a>
    );
  }

  return (
    <div {...css(eventComponentStyle)}>
      <Spacing top={2} bottom={2} left={1} right={1}>
        {textSection}
        {contentThumbnail}
      </Spacing>
      </div>
  );
}

Event.propTypes = propTypes;

export default withStyles(({ color }) => ({
  tagsCopy: {
    color: color.core.babu,
  },
}))(Event);



// WEBPACK FOOTER //
// ./src/components/Event.jsx